import { createSlice } from "@reduxjs/toolkit";
import { fetchIndustrysectorparentItems } from "./IndustrysectorcategoriesThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const industrysectorcategoriesSlice = createSlice({
  name: "industrysectorcategories",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchIndustrysectorparentItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndustrysectorparentItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchIndustrysectorparentItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default industrysectorcategoriesSlice.reducer;